/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-08-16 22:11:48
 *
 *******************************************************/
/// @flow

import React, { Component } from 'react';
import { Field } from 'redux-form';
import { FormLayout, Stack } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import { RenderTextField } from 'src/components/views/common/forms/render-textfield';
import { RenderToggleSwitch } from 'src/components/views/common/forms/render-toggle-switch';
import { isRequired, hasTag, isDelimiter } from 'src/helpers/form-validation-helper';
import { normalizeNumber, normalizeNumberWithComma } from 'src/helpers/form-validation-helper';

const isRequiredValue = isRequired();

type Props = WithI18nProps;

class RangeSlider extends Component<Props, State> {
  render() {
    const { range, themeSetupV2, i18n } = this.props;

    return (
      <FormLayout>
        <Stack distribution="fill">
          <Field
            name={`rangeSlider${range}SliderRange`}
            component={RenderTextField}
            label={i18n.translate('AdminHTML.FilterTree.Item.optionModal_GeneralTab_Field_SliderRange_Label')}
            tooltip={i18n.translate('AdminHTML.FilterTree.Item.optionModal_GeneralTab_Field_SliderRange_Tooltip')}
            validate={[isRequiredValue, hasTag]}
            normalize={(value, prevValue) => normalizeNumber(value, prevValue)}
          />
          <Field
            name={`rangeSlider${range}SliderStep`}
            component={RenderTextField}
            label={i18n.translate('AdminHTML.FilterTree.Item.optionModal_GeneralTab_Field_SliderStep_Label')}
            tooltip={i18n.translate('AdminHTML.FilterTree.Item.optionModal_GeneralTab_Field_SliderStep_Tooltip')}
            validate={[isRequiredValue, hasTag]}
            normalize={(value, prevValue) => normalizeNumberWithComma(value, prevValue)}
          />
          <Field
            name={`rangeSlider${range}SliderDelimiter`}
            component={RenderTextField}
            label={i18n.translate('AdminHTML.FilterTree.Item.optionModal_GeneralTab_Field_Delimiter_Label')}
            validate={[isDelimiter]}
            tooltip={i18n.translate('AdminHTML.FilterTree.Item.optionModal_GeneralTab_Field_Delimiter_Tooltip')}
          />
        </Stack>
        {themeSetupV2 && (
          <Field
            name={`rangeSlider${range}HideTextBoxes`}
            component={RenderToggleSwitch}
            label={i18n.translate('AdminHTML.FilterTree.Item.optionModal_GeneralTab_Field_HideValueTextBoxes_Label')}
          />
        )}
      </FormLayout>
    );
  }
}

export default withI18n()(RangeSlider);
